(() => {
  if (window.__troncaCtaTrackingInstalled) return;
  window.__troncaCtaTrackingInstalled = true;

  const normalize = (value = '') => value
    .toString()
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ');

  const cleanLabel = (element) => {
    const raw = element.getAttribute('aria-label') || element.innerText || element.textContent || element.value || '';
    return raw.replace(/\s+/g, ' ').trim().slice(0, 160);
  };

  const getPlacement = (element) => {
    if (element.matches('.tronca-event-collab__cta') || element.closest('.tronca-event-collab')) return 'top';
    if (element.matches('.tronca-event-story__cta-button') || element.closest('.tronca-event-story__cta')) return 'bottom';
    if (element.closest('header, .section-header, header-drawer')) return 'header';
    if (element.closest('footer, .footer')) return 'footer';
    if (element.closest('[class*="card"], [class*="Card"]')) return 'card';
    if (element.closest('product-info, .product, .product-form')) return 'product';
    return 'page';
  };

  const classify = (element, label, href) => {
    const text = normalize(label);
    const url = normalize(href);

    if (element.matches('.tronca-event-collab__cta, .tronca-event-story__cta-button')) {
      return 'tronca:reservation_click';
    }

    if (text.includes('demander la reservation') || (text.includes('reservation') && (url.includes('degust') || normalize(location.pathname).includes('degust')))) {
      return 'tronca:degustation_reservation_click';
    }

    if (url.includes('wa.me') || url.includes('whatsapp.com') || url.includes('api.whatsapp.com') || text === 'whatsapp') {
      return 'tronca:whatsapp_click';
    }

    const form = element.closest('form');
    const formAction = normalize(form?.getAttribute('action') || '');
    if (
      element.getAttribute('name') === 'add' ||
      formAction.includes('/cart/add') ||
      text.includes('ajouter au panier') ||
      text.includes('add to cart')
    ) {
      return 'tronca:add_to_cart_click';
    }

    if (
      element.getAttribute('name') === 'checkout' ||
      url.includes('/checkout') ||
      text === 'checkout' ||
      text.includes('passer au paiement') ||
      text.includes('commander et payer')
    ) {
      return 'tronca:checkout_click';
    }

    if (
      text === 'livraison' ||
      text === 'emporter' ||
      text === 'a emporter' ||
      text.includes('livraison / emporter')
    ) {
      return 'tronca:fulfillment_intent_click';
    }

    if (
      text === 'commander' ||
      text === 'composer' ||
      text.startsWith('commander ') ||
      text.startsWith('composer ')
    ) {
      return 'tronca:order_intent_click';
    }

    if (text.includes('reserver ma place') || text === 'reserver') {
      return 'tronca:reservation_click';
    }

    if (
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      url.includes('/contact') ||
      text === 'contact' ||
      text === 'nous contacter'
    ) {
      return 'tronca:contact_click';
    }

    if (element.tagName === 'A' && element.closest('header, footer, nav, header-drawer, menu-drawer')) {
      return 'tronca:navigation_click';
    }

    return null;
  };

  const metaEventName = (eventName) => ({
    'tronca:reservation_click': 'TroncaReservationClick',
    'tronca:degustation_reservation_click': 'TroncaDegustationReservationClick',
    'tronca:order_intent_click': 'TroncaOrderIntentClick',
    'tronca:fulfillment_intent_click': 'TroncaFulfillmentIntentClick',
    'tronca:whatsapp_click': 'TroncaWhatsAppClick',
    'tronca:contact_click': 'TroncaContactClick',
    'tronca:add_to_cart_click': 'TroncaAddToCartClick',
    'tronca:checkout_click': 'TroncaCheckoutClick',
    'tronca:navigation_click': 'TroncaNavigationClick'
  }[eventName] || 'TroncaCTAClick');

  const analyticsAllowed = () => {
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed) {
        return Shopify.customerPrivacy.analyticsProcessingAllowed();
      }
    } catch (_) {}
    return false;
  };

  const publish = (eventName, payload) => {
    try {
      if (window.Shopify?.analytics?.publish) {
        Shopify.analytics.publish(eventName, payload);
      }
    } catch (error) {
      console.debug('[Tronca tracking] Shopify publish unavailable', error);
    }

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName.replace(':', '_'), tronca_event_name: eventName, ...payload });
    } catch (_) {}

    try {
      if (analyticsAllowed() && typeof window.fbq === 'function') {
        window.fbq('trackCustom', metaEventName(eventName), payload);
      }
    } catch (_) {}
  };

  document.addEventListener('click', (event) => {
    const element = event.target.closest('a, button, input[type="submit"], input[type="button"], [role="button"]');
    if (!element) return;

    const label = cleanLabel(element);
    const href = element.getAttribute('href') || '';
    const eventName = classify(element, label, href);
    if (!eventName) return;

    const payload = {
      cta_type: eventName.replace('tronca:', ''),
      cta_label: label,
      placement: getPlacement(element),
      page_path: window.location.pathname,
      page_url: window.location.href,
      destination_url: href,
      timestamp: new Date().toISOString()
    };

    publish(eventName, payload);
  }, true);
})();
